import { render, staticRenderFns } from "./MainBiddingDetail.vue?vue&type=template&id=229fc973"
import script from "./MainBiddingDetail.vue?vue&type=script&lang=js"
export * from "./MainBiddingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports